module.exports = __webpack_public_path__ + "img/saddle-cloths-2.69e6fd42.svg";